import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Grid, Link, Box } from '@material-ui/core';
import LoadingButton from '../../common/LoadingButton';
import { useDispatch, useSelector } from 'react-redux';
import AppInput from '../../common/AppInput';
import GiftCardImage from '../../../assets/Giftcard.png';
import GiftCardBalanceFooter from './components/GiftCardBalanceFooter';
import useStyles from './styles';
import { schema } from './validation/schema';
import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';
import GiftcardIcon from '../../common/icons/GiftcardIcon';
import {
  getGiftcardBalance,
  resetBalance,
} from '../../../redux/actions/GiftCardActions';
import Message from '../../common/Message';

const GiftcardBalance = (props) => {
  const { mobile } = props;
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [cardNumber, setCardNumber] = useState('');

  const { status, balance, errorStatus } = useSelector(
    (state) => state.giftCardReducer,
  );

  const getError = () => errorStatus === 429 && status === 'error';

  const defineGenericError = (code) =>
    code === 404
      ? 'La Gift Card ingresada no existe'
      : 'Lo sentimos, estamos presentando inconvenientes. Intenta consultar tu saldo más tarde.';
  const classes = useStyles({ mobile, error: getError() });

  const handleValidation = (event) => {
    const result = schema.validate({ giftCardNumber: event.target.value });
    if ('error' in result) {
      setDisabled(true);
      setErrorMessage(result.error.message);
      setError(true);
      setSuccess(false);
      setCardNumber(event.target.value);
    } else {
      setDisabled(false);
      setErrorMessage('');
      setError(false);
      setSuccess(true);
      setCardNumber(event.target.value);
    }
  };

  const handleReset = () => {
    dispatch(resetBalance());
    setCardNumber('');
    setSuccess(false);
    setError(false);
    setCardNumber('');
  };

  return (
    <Box>
      <ProfileTitle
        mobile={mobile}
        title="Saldo Gift Cards"
        subtitle="Aqui podrás consultar el saldo de tus Gift Cards"
        icon={<GiftcardIcon size="30px" color="#6a148e" />}
      />
      <Paper className={classes.container} elevation={0}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
          className={classes.grid}
          width="100%"
        >
          <Grid item>
            <Typography className={classes.title}>
              Consulta el saldo de tu Gift Card
            </Typography>
          </Grid>
          <Grid item>
            <img src={GiftCardImage} />
          </Grid>
          <Grid item className={classes.itemInput}>
            <Typography variant="h4" data-cy="typo2GiftcardBalance">
              Ingresa el número de tu Gift Card
            </Typography>
            <AppInput
              name="GiftcardBalance"
              helperText="Ingresa 7 o 20 dígitos"
              label="Número de tu Gift Card"
              required
              inputAdornment=""
              error={error}
              errorMessage={errorMessage}
              success={success}
              value={cardNumber}
              disabled={status === 'succeded'}
              onChange={handleValidation}
              onClick={() => {}}
            />
          </Grid>
          {status === 'idle' && (
            <Grid item>
              <LoadingButton
                name="GiftcardBalance"
                loading={status === 'loading'}
                variant="contained"
                color="primary"
                disabled={disabled}
                onClick={() => dispatch(getGiftcardBalance(cardNumber))}
                text="Consultar"
                className={classes.button}
              />
            </Grid>
          )}
        </Grid>
        {status === 'succeded' && (
          <GiftCardBalanceFooter mobile={mobile} balance={balance} />
        )}
        {status === 'error' && (
          <Grid container justify="center" className={classes.grid}>
            <div className={classes.message}>
              <Message
                severity="alert"
                fullRounded
                message={
                  errorStatus === 429 ? (
                    <>
                      Superaste el máximo de consultas de Gift Cards.
                      <br />
                      Vuelve a intentarlo dentro de 1 hora.
                    </>
                  ) : (
                    defineGenericError(errorStatus)
                  )
                }
              />
            </div>
          </Grid>
        )}
      </Paper>
      <Paper className={classes.askContainer} elevation={0}>
        <Grid item>
          <Link
            href="#"
            onClick={!getError() && (() => handleReset())}
            className={classes.askLink}
          >
            Consultar por otra Gift Card
          </Link>
        </Grid>
      </Paper>
    </Box>
  );
};

GiftcardBalance.propTypes = {
  mobile: PropTypes.bool,
};

export default GiftcardBalance;
